import { api } from "../utils/axios";

export async function sendAccessCount() {
    await api.post(
        "/landing/track-visit"
    );
}
